module.exports = "/_next/static/images/2aaf5b3940201786a186d87877a71d43-wow@1x.png";